module.exports = __webpack_public_path__ + "img/icon_search.bb61d84a.svg";